// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3KMqm{margin:auto;padding-top:60px;padding-bottom:50px}.A7p-y{margin-bottom:30px}", ""]);
// Exports
exports.locals = {
	"container": "_3KMqm",
	"title": "A7p-y"
};
module.exports = exports;
